module.exports = __webpack_public_path__ + "static/media/route-weather.b0a2c8bf.png";